var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__outline",
    d: "M121 160l-83 0c-4,0 -8,-2 -10,-4l0 0c-3,-3 -5,-7 -5,-11l0 -121c0,-4 2,-7 5,-10l0 0c2,-3 6,-4 10,-4l11 0 0 -7c0,-1 2,-3 3,-3l2 0c1,0 3,2 3,3l0 7 46 0 0 -7c0,-1 1,-3 3,-3l1 0c2,0 3,2 3,3l0 7 12 0c4,0 8,1 10,4l0 0c3,3 5,6 5,10l0 121 0 1 0 1c-1,3 -3,7 -5,9l0 0c-3,3 -7,4 -11,4zm-14 -132l-1 0c-2,0 -3,-1 -3,-3l0 -6 -46 0 0 6c-1,2 -2,3 -3,3l-2 0c-1,0 -3,-1 -3,-3l0 -6 -11 0c-3,0 -5,2 -5,5l0 121c0,3 2,5 5,5l83 0c3,0 5,-2 6,-5l0 -121c0,-3 -2,-5 -5,-5l-12 0 0 6c0,2 -1,3 -3,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__filled",
    d: "M121 160l-83 0c-4,0 -8,-2 -10,-4l0 0c-3,-3 -5,-7 -5,-11l0 -121c0,-4 2,-7 5,-10l0 0c2,-3 6,-4 10,-4l11 0 0 -7c0,-1 2,-3 3,-3l2 0c1,0 3,2 3,3l0 7 46 0 0 -7c0,-1 1,-3 3,-3l1 0c2,0 3,2 3,3l0 7 12 0c4,0 8,1 10,4l0 0c3,3 5,6 5,10l0 121 0 1 0 1c-1,3 -3,7 -5,9l0 0c-3,3 -7,4 -11,4zm-14 -132l-1 0c-2,0 -3,-1 -3,-3l0 -6 -46 0 0 6c-1,2 -2,3 -3,3l-2 0c-1,0 -3,-1 -3,-3l0 -6 -11 0c-3,0 -5,2 -5,5l0 121c0,3 2,5 5,5l83 0c3,0 5,-2 6,-5l0 -121c0,-3 -2,-5 -5,-5l-12 0 0 6c0,2 -1,3 -3,3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.065d8023.svg";
export { ForwardRef as ReactComponent };